import {
    CREATE_BUSINESS_CLIENT_STARTED,
    CREATE_BUSINESS_CLIENT_SUCCESS,
    CREATE_BUSINESS_CLIENT_FAILURE,
    SEARCH_BUSINESS_CLIENT_STARTED,
    SEARCH_BUSINESS_CLIENT_SUCCESS,
    SEARCH_BUSINESS_CLIENT_FAILURE,
    CLEAR_SEARCH_RESULT,
    REMOVE_ERROR_MESSAGE
} from "../../constants/businessClient/businessClient";

const initialState = {
    clients: [],
    client: null,
    loading: false,
    error: null,
    message: null,
};

export default function businessClient(state = initialState, action) {
    switch (action.type) {
        case CREATE_BUSINESS_CLIENT_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };
        case CREATE_BUSINESS_CLIENT_SUCCESS:
            return {
                ...state,
                client: action.payload.client,
                loading: false,
                error: null,
                message: "Saved client successfully!",
            };
        case CREATE_BUSINESS_CLIENT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                message: null,
            };
        case SEARCH_BUSINESS_CLIENT_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };
        case SEARCH_BUSINESS_CLIENT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                message: null,
                clients: action.payload.clients,
            };
        case SEARCH_BUSINESS_CLIENT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                message: null,
            };
        case CLEAR_SEARCH_RESULT:
            return {
                ...state,
                loading: false,
                error: null,
                message: null,
                clients: [],
            };
        case REMOVE_ERROR_MESSAGE: {
            return {
                ...state,
                loading: false,
                error: null,
                message: null,
            };
        }
        default:
            return {
                ...state,
            };
    }
}


